export default __webpack_public_path__ + "static/media/pig_game.034cc08c.png";